<template>
<b-card no-body>
    <template v-slot:header>
        <i class="fa-solid fa-star"></i> Saved Templates
    </template>
    <b-list-group flush>
        <b-list-group-item class="text-center text-muted">
            <b-input-group>
                <b-form-input placeholder="Search..." v-model="filterQuery"/>
                <template #append>
                    <b-button v-if="filterQuery" variant="warning" @click="filterQuery = ''"><i class="fa-regular fa-arrows-rotate-reverse"></i> Clear</b-button>
                </template>
            </b-input-group>
        </b-list-group-item>
        <template v-if="hasTemplates">
            <TemplateItem v-for="(item, index) in filteredItems" :item="item" :key="item?.id" :is-active="activeTemplate === item.id" @deleted="onDeleted" @selected="onactive"/>
        </template>
        <template v-else>
            <b-list-group-item class="text-center text-muted">No templates</b-list-group-item>
        </template>
    </b-list-group>
</b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import { mapGetters, mapState, mapActions } from 'vuex'
import TemplateItem from './TemplateItem'

import cloneDeep from 'lodash/cloneDeep'

export default ComponentExtension.extend({
    name: "prescription-templates-saved",
    props: {
        isChronic: {
            type: Boolean,
            default: false
        }
    },
    components: {
        TemplateItem,
    },
    data() {
        return {
            filterQuery: "",
            items: [],
            activeTemplate: null
        }
    },
    computed: {
        hasTemplates() {
            return this.filteredItems.length > 0
        },
        filteredItems(){
            let initial = Array.from(this.items)
            return initial.length >= 10 ? initial.slice(0, 10) : [...initial]
        }
    },
    watch: {
        filterQuery: {
            handler() {
                this.lookupItem()
            }
        },
    },
    methods: {
        ...mapActions('prescriptions', ['filterPrescriptionTemplates', 'deletePrescriptionTemplate']),
        onactive(template, templateId) {
            this.activeTemplate = this.activeTemplate === templateId ? null : templateId
            const data = this.activeTemplate ? cloneDeep(template) : null
            EventBus.$emit('prescription-copied-from-template', data)
            EventBus.$emit('prescription-template-loaded-from-template', data)
        },
        onDeleted(id) {
            this.deletePrescriptionTemplate(id).then(() => {
                this.notify("Prescription template removed", "Prescription template was removed successfully")

                EventBus.$emit('prescription-reset-template')
            })
            .catch(errors => {
                this.notify("Error", "Something went wrong", 'danger')
            })
            .finally(() => {
                this.reset()
                this.lookupItem()
            })
        },
        lookupItem() {
            this.filterPrescriptionTemplates({ search: this.filterQuery, is_chronic: this.isChronic })
                .then((results) => {
                    this.items = results
            })
        },
        reset() {
            this.activeTemplate = null
            // this.filterQuery = ""
        },
        fullReset() {
            this.reset()
            this.filterQuery = ""
        }
    },
    async mounted() {
        this.items = await this.filterPrescriptionTemplates({ is_chronic: this.isChronic })
        EventBus.$on('prescription-get-templates', () => {
            this.lookupItem()
        })

        EventBus.$on('prescription-reset-active-template', () => {
            this.reset()
        })
    },
    beforeDestroy() {
         EventBus.$off("prescription-get-templates")
         EventBus.$off("prescription-reset-active-template")
    }
})
</script>